import {axios} from "@/utils"

const endpoints = {
    get_events: '/support/v1/request/events/',
    get_faqs: '/support/v1/request/faqs/',
    send_request: '/support/v1/request/send/'
}

export default {
    async getEvents() {
        const result = await axios.get(endpoints.get_events)
        return result.data
    },
    async getFaqs(event_id) {
        let endpoint = endpoints.get_faqs
        if (event_id && event_id !== 'undefined') endpoint += `?event_id=${event_id}`
        const result = await axios.get(endpoint)
        return result.data
    },
    async sendRequest(payload) {
        await axios.post(endpoints.send_request, payload)
    }
}